<template>
  <div id="maintenance">
    <div class="header flex-between">
      <div class="header-text">
        <h1>顾客维护记录</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          plain
          @click="searchWhSy"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          plain
          @click="createTc"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="iconfont icon-xiugai1"
          plain
          @click="modifyWh"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          plain
          @click="lookBtn"
          >查看</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="iconfont icon-a-shanchu11"
          plain
          @click="deleteFormBtn"
          >删除</el-button
        >
      </div>
    </div>
    <!-- 创建弹窗 -->
    <div class="found">
      <el-dialog
        width="35%"
        title="客户维护记录-创建"
        :visible.sync="foundFormVisible"
        :close-on-click-modal="false"
        @close="CreatedWhClosed"
      >
        <div>
          <el-form
            label-width="100px"
            :model="createFormLabelAlign"
            :rules="createrules"
            ref="createFormRef"
          >
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="会员卡号" prop="cardNo">
                  <div class="flex-start">
                    <el-input
                      style="width: 70%"
                      v-model="createFormLabelAlign.cardNo"
                      disabled
                    >
                    </el-input>
                    <el-button
                      @click="SelecthyWh"
                      style="
                        background-color: #cccccc;
                        color: #4d4d4d;
                        margin-left: 10px;
                      "
                      size="small"
                      >选择会员</el-button
                    >
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="会员姓名" prop="custName">
                  <el-input
                    style="width: 70%"
                    v-model="createFormLabelAlign.custName"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="维护主题" prop="subjectID">
                  <el-select
                    style="width: 80%"
                    v-model="createFormLabelAlign.subjectID"
                  >
                    <el-option
                      v-for="item in optionsThemecj"
                      :key="item.userDefineID"
                      :value="item.userDefineID"
                      :label="item.description_CN"
                    ></el-option>
                  </el-select> </el-form-item
              ></el-col>
              <el-col :span="24">
                <el-form-item label="维护方式" prop="maintainTypeID">
                  <el-select
                    style="width: 80%"
                    v-model="createFormLabelAlign.maintainTypeID"
                  >
                    <el-option
                      v-for="item in optionsTypecj"
                      :key="item.userDefineID"
                      :value="item.userDefineID"
                      :label="item.description_CN"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="维护日期" prop="maintainDate">
                  <el-date-picker
                    style="width: 80%"
                    v-model="createFormLabelAlign.maintainDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="预计到店日期" prop="planDate">
                  <el-date-picker
                    style="width: 80%"
                    v-model="createFormLabelAlign.planDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="维护内容" prop="maintainContext">
                  <el-input
                    style="width: 80%"
                    type="textarea"
                    :rows="3"
                    v-model="createFormLabelAlign.maintainContext"
                  ></el-input> </el-form-item
              ></el-col>
              <el-col :span="24">
                <el-form-item label="是否试衣" prop="isDressing">
                  <el-checkbox-group v-model="createFormLabelAlign.isDressing">
                    <el-checkbox :true-label="1" :false-label="0"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="试衣反馈" prop="dressingFeedback">
                  <el-input
                    style="width: 80%"
                    type="textarea"
                    :rows="3"
                    v-model="createFormLabelAlign.dressingFeedback"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="维护反馈" prop="maintainFeedBack">
                  <el-radio-group
                    v-model="createFormLabelAlign.maintainFeedBack"
                  >
                    <el-radio label="1">感兴趣</el-radio>
                    <el-radio label="2">不感兴趣</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :spam="24">
                <el-form-item label="维护门店" prop="serviceStore">
                  <el-select
                    style="width: 80%"
                    v-model="createFormLabelAlign.serviceStore"
                    @change="Storeevents"
                  >
                    <el-option
                      v-for="item in serviceStorearr"
                      :key="item.shopID"
                      :value="item.shopID"
                      :label="item.shopName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :spam="24">
                <el-form-item label="维护人员" prop="serviceEmpID">
                  <el-select
                    style="width: 80%"
                    v-model="createFormLabelAlign.serviceEmpID"
                  >
                    <el-option
                      v-for="item in serviceEmpIDarr"
                      :key="item.EmpID"
                      :value="item.EmpID"
                      :label="item.EmpName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createSaveBtn('createFormRef')">保 存</el-button>
          <el-button @click="foundFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 选择会员弹窗 -->
      <div class="sales">
        <el-dialog
          width="55%"
          title="顾客维护记录-创建-选择会员"
          :visible.sync="innerVisible"
          :close-on-click-modal="false"
        >
          <div style="width: 570px; margin-top: 10px">
            <el-form size="mini" label-width="200px" :model="SearchFormWhHy">
              <el-form-item label="会员卡号\会员姓名\手机号">
                <div class="flex-between">
                  <el-input
                    style="width: 300px"
                    v-model="SearchFormWhHy.search"
                  >
                  </el-input>
                  <el-button
                    style="
                      width: 80px;
                      margin-left: 10px;
                      background-color: #f1f1f1;
                      color: #b6b388;
                    "
                    size="small"
                    icon="el-icon-search"
                    @click="selectMemberBtn"
                    >查询</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 10px">
            <el-table
              size="small"
              class="table-style"
              border
              height="280px"
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
              }"
              :cell-style="{ 'text-align': 'center' }"
              ref="multipleTable"
              :data="tableData2"
              tooltip-effect="dark"
              v-el-table-infinite-scroll="loadhywh"
              v-loading="loadinghywh"
              infinite-scroll-disabled="onLoadinghywh"
            >
              <el-table-column label width="35">
                <template slot-scope="scope">
                  <el-radio
                    :label="scope.$index"
                    v-model="radiohyWh"
                    @change.native="getHuiYuanRow(scope.row)"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column prop="cardNo" label="会员卡号">
              </el-table-column>
              <el-table-column prop="custName" label="会员姓名">
              </el-table-column>
              <el-table-column prop="mobile" label="手机号"> </el-table-column>
              <el-table-column prop="levelName" label="消费等级">
              </el-table-column>
              <el-table-column prop="regionName" label="所属区域">
              </el-table-column>
              <el-table-column prop="shopName" label="所属门店">
              </el-table-column>
              <el-table-column prop="state" label="维护品牌顾问">
                <template slot-scope="scope">
                  {{ scope.row.state == 0 ? "有效" : "无效" }}
                </template>
              </el-table-column>
            </el-table>
            <el-alert
              v-if="isMorehywh"
              title="没有更多啦!"
              type="warning"
              center
              show-icon
              :closable="false"
            >
            </el-alert>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="SelectHyWhcz">确 定</el-button>
            <el-button @click="innerVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 修改弹窗 -->
    <div class="amend">
      <el-dialog
        width="35%"
        title="顾客维护记录-修改"
        :close-on-click-modal="false"
        :visible.sync="amendFormVisible"
        @close="ModifyWhClosed"
      >
        <div>
          <el-form
            label-width="100px"
            :model="ModifypopupList"
            ref="modifyFormRef"
            :rules="modifyrules"
          >
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="单据号" prop="maintainNo">
                  <el-input
                    disabled
                    v-model="ModifypopupList.maintainNo"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="会员卡号" prop="cardNo">
                  <div class="flex-start">
                    <el-input
                      disabled
                      v-model="ModifypopupList.cardNo"
                      style="width: 70%"
                    >
                    </el-input>
                    <el-button
                      @click="Modifyxzhy"
                      style="
                        background-color: #cccccc;
                        color: #4d4d4d;
                        margin-left: 10px;
                      "
                      size="small"
                      >选择会员</el-button
                    >
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="会员姓名" prop="custName">
                  <el-input
                    disabled
                    v-model="ModifypopupList.custName"
                    style="width: 70%"
                  ></el-input> </el-form-item
              ></el-col>
              <el-col :span="24">
                <el-form-item label="维护主题" prop="subjectID">
                  <el-select
                    v-model="ModifypopupList.subjectID"
                    style="width: 80%"
                  >
                    <el-option
                      v-for="item in optionsThemecj"
                      :key="item.userDefineID"
                      :value="item.userDefineID"
                      :label="item.description_CN"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="维护方式" prop="maintainTypeID">
                  <el-select
                    v-model="ModifypopupList.maintainTypeID"
                    style="width: 80%"
                  >
                    <el-option
                      v-for="item in optionsTypecj"
                      :key="item.userDefineID"
                      :value="item.userDefineID"
                      :label="item.description_CN"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="维护日期" prop="maintainDate">
                  <el-date-picker
                    style="width: 80%"
                    v-model="ModifypopupList.maintainDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="预计到店日期" prop="planDate">
                  <el-date-picker
                    style="width: 80%"
                    v-model="ModifypopupList.planDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="维护内容" prop="maintainContext">
                  <el-input
                    v-model="ModifypopupList.maintainContext"
                    style="width: 80%"
                    type="textarea"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="是否试衣" prop="isDressing">
                  <el-checkbox-group v-model="ModifypopupList.isDressing">
                    <el-checkbox :true-label="1" :false-label="0"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="试衣反馈" prop="dressingFeedback">
                  <el-input
                    v-model="ModifypopupList.dressingFeedback"
                    style="width: 80%"
                    type="textarea"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="维护反馈" prop="maintainFeedBack">
                  <el-radio-group v-model="ModifypopupList.maintainFeedBack">
                    <el-radio :label="1">感兴趣</el-radio>
                    <el-radio :label="2">不感兴趣</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :spam="24">
                <el-form-item label="维护门店" prop="serviceStore">
                  <el-select
                    style="width: 80%"
                    v-model="ModifypopupList.serviceStore"
                    @change="Storeeventsxg"
                  >
                    <el-option
                      v-for="item in serviceStorearr"
                      :key="item.shopID"
                      :value="item.shopID"
                      :label="item.shopName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :spam="24">
                <el-form-item label="维护人员" prop="serviceEmpID">
                  <el-select
                    style="width: 80%"
                    v-model="ModifypopupList.serviceEmpID"
                  >
                    <el-option
                      v-for="item in serviceEmpIDarr"
                      :key="item.EmpID"
                      :value="item.EmpID"
                      :label="item.EmpName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ModifyQd">保 存</el-button>
          <el-button @click="amendFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查看弹窗 -->
    <div class="look">
      <el-dialog
        width="35%"
        title="顾客维护记录-查看"
        :visible.sync="lookFormVisible"
        :close-on-click-modal="false"
        @close="SeeWhlbClose"
      >
        <div>
          <el-form
            label-width="100px"
            :model="lookFormLabelWh"
            ref="SeeWhlbRef"
          >
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="单据号" prop="maintainNo">
                  <el-input
                    disabled
                    v-model="lookFormLabelWh.maintainNo"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="会员卡号" prop="cardNo">
                  <el-input
                    disabled
                    v-model="lookFormLabelWh.cardNo"
                    style="width: 70%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="会员姓名" prop="custName">
                  <el-input
                    disabled
                    v-model="lookFormLabelWh.custName"
                    style="width: 70%"
                  ></el-input> </el-form-item
              ></el-col>
              <el-col :span="24">
                <el-form-item label="维护主题" prop="subjectID">
                  <el-select
                    disabled
                    v-model="lookFormLabelWh.subjectID"
                    style="width: 80%"
                  >
                    <el-option
                      v-for="item in optionsThemecj"
                      :key="item.userDefineID"
                      :value="item.userDefineID"
                      :label="item.description_CN"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="维护方式" prop="maintainTypeID">
                  <el-select
                    disabled
                    v-model="lookFormLabelWh.maintainTypeID"
                    style="width: 80%"
                  >
                    <el-option
                      v-for="item in optionsTypecj"
                      :key="item.userDefineID"
                      :value="item.userDefineID"
                      :label="item.description_CN"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="维护日期" prop="maintainDate">
                  <el-date-picker
                    disabled
                    style="width: 80%"
                    v-model="lookFormLabelWh.maintainDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="预计到店日期" prop="planDate">
                  <el-date-picker
                    disabled
                    style="width: 80%"
                    v-model="lookFormLabelWh.planDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="维护内容" prop="maintainContext">
                  <el-input
                    disabled
                    v-model="lookFormLabelWh.maintainContext"
                    style="width: 80%"
                    type="textarea"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="是否试衣" prop="isDressing">
                  <el-checkbox-group v-model="lookFormLabelWh.isDressing">
                    <el-checkbox
                      :true-label="1"
                      :false-label="0"
                      disabled
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="试衣反馈" prop="dressingFeedback">
                  <el-input
                    disabled
                    v-model="lookFormLabelWh.dressingFeedback"
                    style="width: 80%"
                    type="textarea"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="维护反馈" prop="maintainFeedBack">
                  <el-radio-group
                    disabled
                    v-model="lookFormLabelWh.maintainFeedBack"
                  >
                    <el-radio :label="1">感兴趣</el-radio>
                    <el-radio :label="2">不感兴趣</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :spam="24">
                <el-form-item label="维护门店" prop="serviceStore">
                  <el-select
                    disabled
                    style="width: 80%"
                    v-model="lookFormLabelWh.serviceStore"
                    @change="Storeevents"
                  >
                    <el-option
                      v-for="item in serviceStorearr"
                      :key="item.shopID"
                      :value="item.shopID"
                      :label="item.shopName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :spam="24">
                <el-form-item label="维护人员" prop="serviceEmpID">
                  <el-select
                    disabled
                    style="width: 80%"
                    v-model="lookFormLabelWh.serviceEmpID"
                  >
                    <el-option
                      v-for="item in serviceEmpIDarr"
                      :key="item.EmpID"
                      :value="item.EmpID"
                      :label="item.EmpName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="lookFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        width="20%"
        title="删除会员确认取消对话框"
        :visible.sync="deleteFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">删除</span>维护记录信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteBtn">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 首页查询框 -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="180px" :model="tableDatacs" size="small">
          <el-row>
            <el-col :span="12">
              <el-form-item class="redItem" label="单据号">
                <el-input
                  style="width: 60%"
                  v-model="tableDatacs.maintainNo"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会员卡号\会员姓名\手机号">
                <el-input style="width: 60%" v-model="tableDatacs.search">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="维护主题">
                <el-select style="width: 60%" v-model="tableDatacs.subjectID">
                  <el-option
                    v-for="item in optionsTheme"
                    :key="item.userDefineID"
                    :value="item.userDefineID"
                    :label="item.description_CN"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="维护方式">
                <el-select
                  style="width: 60%"
                  v-model="tableDatacs.maintainTypeID"
                >
                  <el-option
                    v-for="item in optionsType"
                    :key="item.userDefineID"
                    :value="item.userDefineID"
                    :label="item.description_CN"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="维护日期">
                <el-date-picker
                  style="width: 60%"
                  v-model="tableDatacs.fromDate"
                  type="date"
                  placeholder="开始日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="至">
                <el-date-picker
                  style="width: 60%"
                  v-model="tableDatacs.toDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 首页列表数据 -->
    <el-card shadow="never" class="centercard">
      <el-table
        style="width: 100%"
        size="small"
        class="table-style"
        height="500px"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableData"
        v-el-table-infinite-scroll="load"
        v-loading="loading"
        infinite-scroll-disabled="onLoading"
      >
        <!-- radio -->
        <el-table-column width="40">
          <template slot-scope="scope">
            <el-radio
              :label="scope.$index"
              v-model="radio"
              @change="handleRadioChange(scope.row)"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column prop="maintainNo" label="单据号" min-width="90%">
        </el-table-column>
        <el-table-column prop="state" label="是否删除" min-width="60%">
          <template slot-scope="scope">{{
            scope.row.state == 0 ? "否" : "是"
          }}</template>
        </el-table-column>
        <el-table-column prop="cardNo" label="会员卡号" min-width="85%">
        </el-table-column>
        <el-table-column prop="custName" label="会员姓名"> </el-table-column>
        <el-table-column prop="subjectName" label="维护主题"> </el-table-column>
        <el-table-column prop="maintainType" label="维护方式">
        </el-table-column>
        <el-table-column prop="maintainDate" label="维护日期">
          <template slot-scope="scope">
            <div v-if="scope.row.maintainDate !== null">
              {{ scope.row.maintainDate | dateFormat }}
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column label="预计到店日期">
          <template slot-scope="scope">
            <div v-if="scope.row.planDate !== null">
              {{ scope.row.planDate | dateFormat }}
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column prop="isDressing" label="是否试衣">
          <template slot-scope="scope">{{
            scope.row.isDressing == true ? "是" : "否"
          }}</template>
        </el-table-column>
        <el-table-column prop="maintainFeedBack" label="维护反馈">
          <template slot-scope="scope">
            {{
              scope.row.maintainFeedBack == 1
                ? "感兴趣"
                : scope.row.maintainFeedBack == 2
                ? "不感兴趣"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="createEmpName" label="创建人"> </el-table-column>
        <el-table-column prop="createTime" label="创建日期">
          <template slot-scope="scope">
            <div v-if="scope.row.createTime !== null">
              {{ scope.row.createTime | dateFormat }}
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column prop="updateEmpName" label="最后修改人">
        </el-table-column>
        <el-table-column prop="updateTime" label="最后修改日期">
          <template slot-scope="scope">
            <div v-if="scope.row.updateTime !== null">
              {{ scope.row.updateTime | dateFormat }}
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="isMore"
        title="没有更多啦!"
        type="warning"
        center
        show-icon
        :closable="false"
      >
      </el-alert>
    </el-card>
  </div>
</template>

<script>
import { dateTimes } from "@/utils/auth";
import {
  selectCustListApi,
  maintainPageApi,
  definedqueryListApi,
  maintainQueryApi,
  maintainDeleteApi,
  maintainInsertApi,
  maintainUpdateApi,
  SysempselectEmpApi,
  shopSelectByCodewhApi,
} from "@/api/shop";
export default {
  name: "centre",
  data() {
    return {
      radioValueWhList: [], //首页选中的数据
      radioValueWhxzhyList: [], //选择会员中选中的数据
      deleteFormVisible: false,
      // 创建弹窗
      foundFormVisible: false,
      // 修改弹窗
      amendFormVisible: false,
      // 查看弹窗
      lookFormVisible: false,
      // 创建内部弹窗
      innerVisible: false,
      // 首页radio
      radio: "",
      // 选择会员radio
      radiohyWh: "",
      // 懒加载
      loading: false,
      loadinghywh: false,

      searchFormLAlign: {
        name: "",
        region: "",
        subjectName_CN: "",
      },

      optionsTheme: [], //主题
      optionsType: [], //类型
      optionsThemecj: [],
      optionsTypecj: [],
      serviceEmpIDarr: [], //人员
      serviceStorearr: [], //门店
      // serviceEmpIDarrzb:[], //人员数组
      serviceStorearrzb: [], //门店数组
      // 创建弹窗列表
      createFormLabelAlign: {
        cardNo: "",
        custID: "",
        custName: "",
        subjectID: "",
        maintainTypeID: "",
        maintainDate: "",
        planDate: "",
        maintainContext: "",
        dressingFeedback: "",
        isDressing: 0,
        maintainFeedBack: "",
        serviceEmpID: "", // 维护人员
        serviceStore: "", // 维护门店
      },
      // 创建弹窗选择会员请求参数
      SelectmemberWh: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        pages: 0,
      },
      // 创建弹窗选择会员列表查询参数
      SearchFormWhHy: {
        search: "",
        pageNo: 1,
        pageSize: 50,
      },
      // 查看
      lookFormLabelWh: {},
      // 查看请求参数
      lookFormLabelWhcs: {
        maintainID: "",
      },
      // 修改弹窗
      ModifypopupList: {
        maintainNo: "", // 单据号
        cardNo: "",
        custName: "",
        subjectID: "",
        maintainTypeID: "",
        maintainDate: "",
        planDate: "",
        maintainContext: "",
        dressingFeedback: "",
        isDressing: "",
        maintainFeedBack: "",
        custID: "", // 顾客custID
        maintainID: "",
        serviceEmpID: "", // 维护人员
        serviceStore: "", // 维护门店
      },
      // 顾客维护记录删除delete
      DeleteWhlb: {
        maintainID: "",
      },
      //
      // form: {
      //   name: "",
      //   region: "",
      //   date1: "",
      //   date2: "",
      //   delivery: false,
      //   type: [],
      //   resource: "",
      //   desc: "",
      // },
      // 首页列表查询参数
      queryInfo: {
        search: "",
        maintainNo: "",
        subjectID: "",
        maintainTypeID: "",
        fromDate: "",
        toDate: "",
        custID: "",
        pageNo: 1,
        pageSize: 50,
      },
      // 首页列表请求参数
      tableDatacs: {
        pageNo: 1,
        pageSize: 50,
        pages: 0,
        search: "",
        maintainNo: "",
        subjectID: "",
        maintainTypeID: "",
        fromDate: "",
        toDate: "",
        custID: "",
      },
      // 首页列表数据
      tableData: [],
      // 内层弹窗数据
      tableData2: [],
      // 创建验证表单
      createrules: {
        cardNo: [
          { required: true, message: "请选择会员卡号", trigger: "blur" },
        ],
        custName: [
          { required: true, message: "请输入会员姓名", trigger: "blur" },
        ],
        subjectID: [
          { required: true, message: "请选择维护主题", trigger: "change" },
        ],
        maintainTypeID: [
          { required: true, message: "请选择维护方式", trigger: "change" },
        ],
        maintainDate: [
          { required: true, message: "请选择维护日期", trigger: "change" },
        ],
      },
      // 修改验证表单
      modifyrules: {
        maintainNo: [
          { required: true, message: "请输入单据号", trigger: "blur" },
        ],
        cardNo: [
          { required: true, message: "请输入会员卡号", trigger: "blur" },
        ],
        custName: [
          { required: true, message: "请输入会员姓名", trigger: "blur" },
        ],
        subjectID: [
          { required: true, message: "请选择维护主题", trigger: "change" },
        ],
        maintainTypeID: [
          { required: true, message: "请选择维护方式", trigger: "change" },
        ],
        maintainDate: [
          { required: true, message: "请选择维护日期", trigger: "change" },
        ],
      },
      // 获取人员参数
      orgID: "",
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        look: false,
        delete: false,
      },
    };
  },
  created() {
    this.getSubjectList(); //主题
    this.getTypeList(); //类型
    this.maintainList(); //首页列表
    this.shopSelectByCodewhList(); //门店
    let Maintenance = JSON.parse(localStorage.getItem("Maintenance"));
    console.log(Maintenance);
    for (let i = 0; i < Maintenance.length; i++) {
      if (Maintenance[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Maintenance[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Maintenance[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }
      if (Maintenance[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
      if (Maintenance[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
    }
  },
  computed: {
    // 首页
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.tableDatacs.pageNo >= this.tableDatacs.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    // 创建弹窗选择会员
    isMorehywh() {
      //当起始页数等于总页数时停止加载
      return this.SelectmemberWh.pageNo >= this.SelectmemberWh.pages;
    },
    onLoadinghywh() {
      return this.loadinghywh || this.isMorehywh;
    },
  },
  methods: {
    // 获取维护门店
    shopSelectByCodewhList() {
      shopSelectByCodewhApi({ shopCode: "" }).then((res) => {
        this.serviceStorearrzb = res.data;
      });
    },
    // 创建弹窗选择门店事件
    Storeevents(val) {
      this.orgID = val;
      this.SysempselectEmpList();
      this.createFormLabelAlign.serviceEmpID = "";
      // this.serviceEmpIDarr = this.serviceEmpIDarrzb
    },
    // 修改弹窗选择门店事件
    Storeeventsxg(val) {
      this.orgID = val;
      this.SysempselectEmpList();
      this.ModifypopupList.serviceEmpID = "";
      // this.serviceEmpIDarr = this.serviceEmpIDarrzb
    },
    // 获取维护人员
    SysempselectEmpList() {
      SysempselectEmpApi({ orgID: this.orgID }).then((res) => {
        this.serviceEmpIDarr = res.data;
      });
    },
    // 点击radio获取首页表格数据
    handleRadioChange(value) {
      this.radioValueWhList = value;
      value;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 获取主题
    async getSubjectList() {
      await definedqueryListApi({ defineKindIDs: 32 }).then((res) => {
        this.optionsThemecj = res.data[32];
        if (res.success) {
          this.optionsTheme.push({
            userDefineID: "",
            description_CN: "全部主题",
          });
          this.optionsTheme.push(...res.data[32]);
        }
      });
    },
    // 获取类型
    async getTypeList() {
      await definedqueryListApi({ defineKindIDs: 33 }).then((res) => {
        this.optionsTypecj = res.data[33];
        if (res.success) {
          this.optionsType.push({
            userDefineID: "",
            description_CN: "全部方式",
          });
          this.optionsType.push(...res.data[33]);
        }
      });
    },
    // 获取首页列表
    async maintainList() {
      await maintainPageApi(this.tableDatacs).then((res) => {
        if (this.tableDatacs.pageNo == 1) this.tableData = [];
        this.tableData = this.tableData.concat(res.data.list);
        this.tableDatacs.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      //滑到底部时进行加载
      this.loading = true;
      setTimeout(() => {
        this.tableDatacs.pageNo += 1;
        this.maintainList();
      }, 1000);
    },
    // 查询
    async searchWhSy() {
      this.radio = "";
      this.radioValueWhList = "";
      this.tableDatacs.pageNo = 1;
      await maintainPageApi(this.tableDatacs).then((res) => {
        if (res.message !== "success") {
          this.$message.error("查询会员失败");
          return;
        }
        this.$message.success("查询会员成功");
        this.tableData = res.data.list;
        this.tableDatacs.pages = res.data.pages;
      });
    },
    // 维护记录创建按钮点击事件
    createTc() {
      this.serviceStorearr = this.serviceStorearrzb;
      this.foundFormVisible = true;
    },
    // 维护记录创建
    createSaveBtn(createFormRef) {
      this.$refs[createFormRef].validate(async (valid) => {
        if (!valid) return;
        let createForm = {
          cardNo: this.createFormLabelAlign.cardNo,
          custID: this.createFormLabelAlign.custID,
          custName: this.createFormLabelAlign.custName,
          subjectID: this.createFormLabelAlign.subjectID,
          maintainTypeID: this.createFormLabelAlign.maintainTypeID,
          maintainDate: this.createFormLabelAlign.maintainDate,
          planDate:
            this.createFormLabelAlign.planDate != ""
              ? dateTimes(this.createFormLabelAlign.planDate)
              : "",
          maintainContext: this.createFormLabelAlign.maintainContext,
          dressingFeedback: this.createFormLabelAlign.dressingFeedback,
          isDressing: this.createFormLabelAlign.isDressing,
          maintainFeedBack: this.createFormLabelAlign.maintainFeedBack,
          serviceEmpID: this.createFormLabelAlign.serviceEmpID, // 维护人员
          serviceStore: this.createFormLabelAlign.serviceStore, // 维护门店
        };
        await maintainInsertApi(createForm).then((res) => {
          if (res.message !== "success") {
            this.$message.error("创建维护记录失败");
            return;
          }
          this.$message.success("创建维护记录成功");
          // 隐藏创建维护记录对话框
          this.foundFormVisible = false;
          // 重新获取维护记录列表
          this.maintainList();
          this.radio = "";
          this.radioValueWhList = "";
        });
      });
    },
    // 创建弹窗点击选择会员事件
    SelecthyWh() {
      this.SelectmemberWhList();
      this.innerVisible = true;
    },
    // 修改弹窗点击选择会员事件
    Modifyxzhy() {
      this.SelectmemberWhList();
      this.innerVisible = true;
    },
    // 监听创建对话框的关闭事件
    CreatedWhClosed() {
      this.$refs.createFormRef.resetFields();
    },
    // 监听修改对话框的关闭事件
    ModifyWhClosed() {
      this.$refs.modifyFormRef.resetFields();
      this.serviceEmpIDarr = [];
    },
    // 监听查看弹框的关闭事件
    SeeWhlbClose() {
      this.$refs.SeeWhlbRef.resetFields();
      this.serviceEmpIDarr = [];
    },
    // 选择会员列表
    async SelectmemberWhList() {
      await selectCustListApi(this.SelectmemberWh).then((res) => {
        this.tableData2 = res.data.list;
        this.SelectmemberWh.pages = res.data.pages;
        this.loadinghywh = false;
      });
    },
    loadhywh() {
      //滑到底部时进行加载
      this.loadinghywh = true;
      setTimeout(() => {
        this.SelectmemberWh.pageSize += 50; //页面数据每次+50
        this.SelectmemberWhList(); //调用接口，此时页面数据+50，获取下一次50数据
      }, 1000);
    },
    // 选择会员列表查询
    async selectMemberBtn() {
      await selectCustListApi(this.SearchFormWhHy).then((res) => {
        this.tableData2 = res.data.list;
      });
    },
    // 选择会员radio选中数据
    getHuiYuanRow(row) {
      this.radioValueWhxzhyList = row;
    },
    // 选择会员列表点击确定将radio选中数据传值
    SelectHyWhcz() {
      // 点击确定赋值给修改弹窗
      this.ModifypopupList.cardNo = this.radioValueWhxzhyList.cardNo;
      this.ModifypopupList.custName = this.radioValueWhxzhyList.custName;
      this.ModifypopupList.custID = this.radioValueWhxzhyList.custID;
      // 点击确定赋值给创建弹窗
      this.createFormLabelAlign.custID = this.radioValueWhxzhyList.custID;
      this.createFormLabelAlign.cardNo = this.radioValueWhxzhyList.cardNo;
      this.createFormLabelAlign.custName = this.radioValueWhxzhyList.custName;
      this.innerVisible = false;
    },
    // 顾客维护记录修改按钮事件
    modifyWh() {
      if (this.radioValueWhList.length == 0) {
        this.$message.error("请选择单条数据，进行修改");
      } else {
        this.modifyWhlb();
        this.serviceStorearr = this.serviceStorearrzb;
        if (this.ModifypopupList.serviceStore !== null) {
          SysempselectEmpApi({ orgID: this.ModifypopupList.serviceStore }).then(
            (res) => {
              this.serviceEmpIDarr = res.data;
            }
          );
        }
        this.amendFormVisible = true;
      }
    },
    // 点击修改按钮将单据号传给修改弹窗列表
    modifyWhlb() {
      this.ModifypopupList.maintainID = this.radioValueWhList.maintainID;
      this.ModifypopupList.maintainNo = this.radioValueWhList.maintainNo;
      this.ModifypopupList.custName = this.radioValueWhList.custName;
      this.ModifypopupList.cardNo = this.radioValueWhList.cardNo;
      this.ModifypopupList.custID = this.radioValueWhList.custID;
      this.ModifypopupList.subjectID = this.radioValueWhList.subjectID;
      this.ModifypopupList.maintainTypeID =
        this.radioValueWhList.maintainTypeID;
      this.ModifypopupList.maintainDate = this.radioValueWhList.maintainDate;
      this.ModifypopupList.planDate = this.radioValueWhList.planDate;
      this.ModifypopupList.maintainContext =
        this.radioValueWhList.maintainContext;
      this.ModifypopupList.isDressing = this.radioValueWhList.isDressing;
      this.ModifypopupList.dressingFeedback =
        this.radioValueWhList.dressingFeedback;
      this.ModifypopupList.maintainFeedBack =
        this.radioValueWhList.maintainFeedBack;
      this.ModifypopupList.serviceStore = this.radioValueWhList.serviceStore;
      this.ModifypopupList.serviceEmpID = this.radioValueWhList.serviceEmpID;
    },
    // 修改顾客维护记录确定事件
    async ModifyQd() {
      let Modify = {
        maintainNo: this.ModifypopupList.maintainNo, // 单据号
        cardNo: this.ModifypopupList.cardNo,
        custName: this.ModifypopupList.custName,
        subjectID: this.ModifypopupList.subjectID,
        maintainTypeID: this.ModifypopupList.maintainTypeID,
        maintainDate: this.ModifypopupList.maintainDate,
        planDate:
          this.ModifypopupList.planDate != null
            ? dateTimes(this.ModifypopupList.planDate)
            : "",
        maintainContext: this.ModifypopupList.maintainContext,
        dressingFeedback: this.ModifypopupList.dressingFeedback,
        isDressing: this.ModifypopupList.isDressing,
        maintainFeedBack: this.ModifypopupList.maintainFeedBack,
        custID: this.ModifypopupList.custID, // 顾客custID
        maintainID: this.ModifypopupList.maintainID,
        serviceEmpID: this.ModifypopupList.serviceEmpID, // 维护人员
        serviceStore: this.ModifypopupList.serviceStore, // 维护门店
      };
      await maintainUpdateApi(Modify).then((res) => {
        if (res.message !== "success") {
          this.$message.error("修改顾客维护记录失败");
          return;
        }
        this.$message.success("修改顾客维护记录成功");
        // 重新获取顾客维护列表
        this.maintainList();
        this.radio = "";
        this.radioValueWhList = "";
      });
      // 关闭弹窗
      this.amendFormVisible = false;
    },
    //顾客维护记录 -- 查看
    lookBtn() {
      if (this.radioValueWhList.length == 0) {
        this.$message.error("请选择单条数据，进行查看");
      } else {
        // 获取maintainID
        this.lookWhqq();
        // 发送请求查看记录
        maintainQueryApi(this.lookFormLabelWhcs).then((res) => {
          this.lookFormLabelWh = res.data;
          if (res.message !== "success") {
            this.$message.error("查看顾客维护记录失败");
            return;
          }
          this.serviceStorearr = this.serviceStorearrzb;
          if (this.lookFormLabelWh.serviceStore !== null) {
            SysempselectEmpApi({
              orgID: this.lookFormLabelWh.serviceStore,
            }).then((res) => {
              this.serviceEmpIDarr = res.data;
            });
          }
          this.$message.success("查看顾客维护记录成功");
        });
        this.lookFormVisible = true;
      }
    },
    // 获取maintainID
    lookWhqq() {
      this.lookFormLabelWhcs.maintainID = this.radioValueWhList.maintainID;
    },
    // 顾客维护记录 -- 删除
    deleteBtn() {
      if (this.radioValueWhList.state == 0) {
        this.maintainDeleteApi();
        return;
      }
      {
        this.$message.error("删除记录失败！");
      }
    },
    async maintainDeleteApi() {
      await maintainDeleteApi(this.DeleteWhlb).then((res) => {
        if (res.message !== "success") {
          this.$message.error("删除顾客维护记录失败");
          return;
        }
        this.$message.success("删除顾客维护记录成功");
        // 重新获取顾客维护列表
        this.maintainList();
        this.radio = "";
        this.radioValueWhList = "";
      });
      // 关闭弹窗
      this.deleteFormVisible = false;
    },
    // 判断有没有选中数据 获得maintainID
    deleteFormBtn() {
      if (this.radioValueWhList.length == 0) {
        this.$message.error("请选择单条数据，进行删除!");
      } else {
        this.deleteFormVisible = true;
        this.deletewhqq();
      }
    },
    // 获取maintainID
    deletewhqq() {
      this.DeleteWhlb.maintainID = this.radioValueWhList.maintainID;
    },
  },
};
</script>
<style lang="scss" scoped>
#maintenance {
  height: 100%;
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }

  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 修改弹窗样式
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 20px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }

    .el-form-item {
      margin-bottom: 10px;
    }
    .el-input__inner {
      height: 30px;
      background-color: #ffffff;
    }
  }
  // 创建弹窗样式
  .found {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 20px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }

    .el-form-item {
      margin-bottom: 10px;
    }
    .el-input__inner {
      height: 30px;
      background-color: #ffffff;
    }
  }
  // 查看弹窗样式
  .look {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 20px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }

    .el-form-item {
      margin-bottom: 10px;
    }
    .el-input__inner {
      height: 30px;
      background-color: #ffffff;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
}
</style>
